import React from 'react';
// import { useSignals } from '@preact/signals-react/runtime';
import jsonData from '../../signals/jsonData';
import appState from '../../signals/appState';
import translation from '../../signals/translations';
import textareaToHTML from '../../tools/textareaToHTML';
import IconClose from '../../icons/IconClose';

const ExhibitionInfo = () => {
	// useSignals();

	const { basicInfo } = jsonData.value;
	const { ExhibitionInfo } = appState.value;

	const closePopup = () => {
		appState.value = {
			...appState.value,
			ExhibitionInfo: false,
		};
	}

	if (!ExhibitionInfo) return null;
	console.log('ExhibitionInfo', basicInfo);

	return (
		<div id='ExhibitionInfo' className={ExhibitionInfo ? 'active' : ''} >
			<div className='center-wrap'>
				<IconClose onClick={closePopup} />
				<div className='title'>{translation('leftPanel.exhibitionInfo')}</div>
				<div className='content' dangerouslySetInnerHTML={{ __html: textareaToHTML(basicInfo.intro) }} />
				{basicInfo.link && (
					<div className='link-wrap'>
						<div className='title'>展覽連結</div>
						<a href={basicInfo.link} target='_blank' rel='noreferrer noopener'>{basicInfo.link}</a>
					</div>
				)}
			</div>
		</div>
	)
}

export default ExhibitionInfo;